export const DefaultColors = [
    '#E71F1A',
    '#EC078D',
    '#FAEE00',
    '#F39800',
    '#924F9B',
    '#4A459A',
    '#1A499D',
    '#62B0E3',
    '#6BB82E',
    '#1C923B',
    '#B28247',
    '#00A29A',
    '#231916',
    '#595857',
    '#B5B5B6',
    '#FFFFFF',
];


export const DefaultPanelColors = [
    '#bf0101',
    '#ff0000',
    '#e92fea',
    '#ffbf00',
    '#ffff00',
    '#91cf50',
    '#02af4f',
    '#02afef',
    '#016fbf',
    '#001f5f',
    '#ffffff',
    '#585656',
    '#000000',
    '#653200',
    '#c3874b'
]

export const DefaultBorderColors = [
    '#E71F1A',
    '#FAEE00',
    '#00761A',
    '#0000FF',
    '#000000',
];

export const DefaultFillColors = [
    '#FAEE00',
    '#D4067F',
    '#00761A',
    '#0000FF',
    '#F39800',
];

export const DefaultPanelBackgroundColors = [
    '#FAEE00',
    '#EC078D',
    '#00761a',
    '#0000ff',
    '#F39800',
    '#ffffff'
];